import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

const columns = [
  { field: "rail", label: "Zonal Railway" },
  { field: "trolly_type", label: "Type of Trolly" },
  { field: "nooftrolly", label: "No. of Trolly" },
  { field: "coachset", label: "Coach Set" },
  { field: "labourcost", label: "Labour Cost" },
  { field: "materialcost", label: "Material Cost" },
  { field: "totalcost", label: "Total Cost" },
];

export default function WGRTable({
  rows,
  shop,
  totals,
  showTotal = true,
}) {
  return (
    <TableContainer>
      <Table
        size="small"
        stickyHeader
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                align="right"
                sx={{
                  fontWeight: 700,
                  bgcolor: "grey.200",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={index}
              hover
              sx={{
                "&:nth-of-type(even)": {
                  bgcolor: "grey.50",
                },
              }}
            >
              <TableCell align="right">{row.rail}</TableCell>

              <TableCell align="right">
                {row.trolly_type}
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={row.nooftrolly} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={row.coachset} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={row.labourcost} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={row.materialcost} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={row.totalcost} />
              </TableCell>
            </TableRow>
          ))}

          {showTotal && (
            <TableRow
              sx={{
                bgcolor: "primary.light",
                "& td": {
                  fontWeight: 700,
                  borderTop: "2px solid",
                  borderColor: "primary.main",
                },
              }}
            >
              <TableCell colSpan={2} align="center">
                {shop} Total
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.trolly} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.coachset} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.labourcost} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.materialcost} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.totalcost} />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}